<template>
  <div class="main col-xs-12">
    <h1>Dashboard</h1>

    <div class="row">
      <div class="col-xs-6">
        <form @submit.prevent="searchPo" class="search noborder">
          <input v-model="searchinputpo" placeholder="Search Purchase Order" class="input form-search" />
          <font-awesome-icon :icon="['far', 'search']" class="search__icon" />
          <button class="button button--search" type="submit">Search</button>
        </form>

        <div class="certificates__block" v-if="posearchresults">
          <h3 class="list__header">Search results</h3>
          <AppPagination :list-data="posearchresults" />
        </div>
      </div>

      <div class="col-xs-6">
        <form @submit.prevent="searchBatch" class="search noborder">
          <input v-model="searchinputbatch" placeholder="Search Batch No" class="input form-search" />
          <font-awesome-icon :icon="['far', 'search']" class="search__icon" />
          <button class="button button--search" type="submit">Search</button>
        </form>

        <div class="certificates__block" v-if="batchsearchresults">
          <h3 class="list__header">Search results</h3>
          <AppPagination :list-data="batchsearchresults" />
        </div>
      </div>
    </div>

    <AppCertificates v-bind:missingBatches="this.missingBatches"
                     v-bind:draftBatches="this.draftBatches"
                     v-bind:productsMissingCerts="this.productsMissingCerts" />

  </div>
</template>

<script>
  import axios from 'axios';
  import AppCertificates from '@/components/AppCertificates/AppCertificates.vue';
  import AppPagination from '@/components/AppPagination/AppPagination.vue';

  export default {
    name: 'home',
    components: {
      AppCertificates,
      AppPagination,
    },
    data() {
      return {
        posearchresults: null,
        batchsearchresults: null,
        missingBatches: [],
        draftBatches: [],
        productsMissingCerts: [],
        searchinputpo: '',
        searchinputbatch: '',
      };
    },
    methods: {
      searchPo() {
        this.$Progress.start();
        const urlPo = `/purchase-orders/${this.searchinputpo}`;

        axios
          .get(urlPo)
          .then((response) => {
            this.posearchresults = response.data;
            this.$Progress.finish();
          })
          .catch((error) => {
            this.$Progress.fail();
          });
      },
      searchBatch() {
        this.$Progress.start();
        const urlBatch = `/batches?query=${this.searchinputbatch}`;

        axios
          .get(urlBatch)
          .then((response) => {
            this.batchsearchresults = response.data;
            this.$Progress.finish();
          })
          .catch((error) => {
            this.$Progress.fail();
          });
      },
    },
    mounted() {

      var tenant = document.getElementsByName('brand');

      if (tenant != null) {
        this.$Progress.start();
        axios.get('/dashboard-data')
          .then((response) => {
            this.missingBatches = response.data.missingBatches;
            this.draftBatches = response.data.draftBatches;
            this.productsMissingCerts = response.data.productsMissingCerts;
            this.$Progress.finish();
          })
          .catch((error) => {
            this.errored = true;
            this.$Progress.fail();
          });
      }

      this.$root.$on('getDashboardData', () => {

        this.$Progress.start();

        this.missingBatches = {};
        this.draftBatches = {};
        this.productsMissingCerts = {};

        axios.get('/dashboard-data').then((response) => {
          this.missingBatches = response.data.missingBatches;
          this.draftBatches = response.data.draftBatches;
          this.productsMissingCerts = response.data.productsMissingCerts;
          this.$Progress.finish();
        })
          .catch((error) => {
            this.errored = true;
            this.$Progress.fail();
          });
      })
    },
  };
</script>
